import { gql } from 'graphql-request'

export const CREATE_BOOKMARK = gql`
  mutation CreateBookmark($createBookmarkInput: CreateBookmarkInput!) {
    createBookmark(createBookmarkInput: $createBookmarkInput) {
      id
    }
  }
`
